import clsx from "clsx";

export const RMCCard = ({ className, children, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={clsx("bg-blackhue-rmc_hue rounded-[10px] p-5", className)}
    >
      {children}
    </div>
  );
};
